export class SinglePromise {
    constructor(options) {
        this.clientId = options?.clientId || '';
        globalThis.jsSdkFnPromiseMap = (globalThis.jsSdkFnPromiseMap || new Map());
    }
    async run(key, fn) {
        key = `${this.clientId}_${key}`;
        let result = globalThis.jsSdkFnPromiseMap.get(key);
        if (!result) {
            result = new Promise((resolve, reject) => {
                (async () => {
                    try {
                        await this.runIdlePromise();
                        const fnResult = fn();
                        resolve(await fnResult);
                    }
                    catch (error) {
                        reject(error);
                    }
                    finally {
                        globalThis.jsSdkFnPromiseMap.delete(key);
                    }
                })();
            });
            globalThis.jsSdkFnPromiseMap.set(key, result);
        }
        return result;
    }
    runIdlePromise() {
        return Promise.resolve();
    }
}
